import axios from 'axios';

export const workflowContainerVideosApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-container-videos`,
    headers: {
        'Content-Type': 'application/json'
    }
})